<div class="dialog-overlay">
    <div class="content">
        <ng-container *ngIf="isSaving && !hasErrorSave">
            <div class="saving-spinner"></div>
            <div class="title-text">
                {{ 'mimic.save-dialog.title' | translate }}
            </div>
            <div class="message-text">
                {{ 'mimic.save-dialog.message' | translate }}
            </div>
            <ng-container *ngIf="displaySlowText">
                <div class="error-text">
                    {{ 'mimic.save-dialog.slow-text' | translate }}
                </div>
                <ng-container *ngTemplateOutlet="buttonsTemplate"></ng-container>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="hasErrorSave && !isSaving">
            <mat-icon svgIcon="save-error" />
            <div class="title-text">
                {{ 'mimic.save-dialog.title.error' | translate }}
            </div>
            <div class="message-text">
                {{ 'mimic.save-dialog.message.error' | translate }}
            </div>
            <ng-container *ngTemplateOutlet="buttonsTemplate"></ng-container>
        </ng-container>
    </div>
</div>

<ng-template #buttonsTemplate>
    <div class="buttons-container">
        <div class="button cancel" (click)="cancel()">
            {{ 'mimic.save-dialog.button.cancel' | translate }}
        </div>
        <div class="right-buttons">
            <div class="button discard" (click)="cancel()">
                {{ 'mimic.save-dialog.button.discard' | translate }}
            </div>
            <div class="button report" (click)="report()">
                {{ 'mimic.save-dialog.button.report' | translate }}
            </div>
        </div>
    </div>
</ng-template>
